export default "__VITE_ASSET__BgIzatK2__"